import React, { useEffect } from 'react'
import { INIT_TITLE } from '../../configurations/initUrls'
import useRegisterPush from '../../configurations/push/pushNotification'
import useAuth from '../../configurations/auth/publicUsers/useAuth'
import { Capacitor } from '@capacitor/core'

export default function ContainerPublic({ children, bg = "", isFlex = false, title = "" }) {
    useEffect(() => {
        document.title = (title ? title + " | " : "") + INIT_TITLE
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        })
    }, [])

    return (
        <>
            <div className={`${isFlex ? "flex" : ""} h-full no-wrap `}>
                {children}
            </div>
        </>
    )
}
